export const DEPOSIT_WIZARD_TYPES = {
  ACH: 'ach',
  WIRE: 'wire',
  CHECK: 'check',
};
